import { all, fork } from 'redux-saga/effects';
import modulesSagaWatcher from '@pages/modules/store/sagas';
import authSagaWatcher from '@features/auth/store/sagas';
import usersSagaWatcher from '@features/users/store/sagas';
import standsWatcherSaga from '@pages/stands/store/sagas';
import commonSagaWatcher from '@features/favorites/store/sagas';
import createSagaMiddleware, { Saga } from 'redux-saga';
import { AsyncReducers } from './rootReducer';
import teamsSagaWatcher from '@features/teams/store/sagas';

export default function* createStaticRootSaga() {
    yield all([
        fork(modulesSagaWatcher),
        fork(authSagaWatcher),
        fork(usersSagaWatcher),
        fork(standsWatcherSaga),
        fork(commonSagaWatcher),
        fork(teamsSagaWatcher),
    ]);
}

const asyncSagas: Partial<Record<keyof AsyncReducers, boolean>> = {};

export const sagaMiddleware = createSagaMiddleware();

export const injectSaga = (key: keyof AsyncReducers, saga: Saga) => {
    if (!asyncSagas[key]) {
        asyncSagas[key] = true;
        sagaMiddleware.run(saga);
    }
};
